import React from "react";
import autoBind from 'react-autobind';
//
import CustomComponent from '@/components/CustomComponent';
//
export default class AdminDispatchView extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  
  render() {
    return (<h1>AdminDispatchView</h1>)
  }
}
